import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Header } from './Header'
import { Buttons } from './Buttons'
import PublicEventsDispatcher from 'common/services/PublicEventsDispatcher'

import './style.css.scss'

const { EventTypes, dispatch: dispatchPublicEvent } = PublicEventsDispatcher()

function LiveEvent(props) {
  useEffect(() => {
    dispatchPublicEvent(EventTypes.liveEventMounted)
  }, [])

  return (
    <section className={`live-event ${props.isItemView ? 'live-event-with-item-view' : ''}`}>
      <Header
        title={props.config.title}
        subtitle={props.config.subtitle}
        themeColorHex={props.themeColorHex} />
      {props.children}
      <Buttons buttons={props.buttons}/>
    </section>
  )
}

LiveEvent.propTypes = {
  config: PropTypes.object.isRequired,
  buttons: PropTypes.array,
  isItemView: PropTypes.bool,
  themeColorHex: PropTypes.string
}

export default LiveEvent
